export const change = (value, questionId) => ({
  type: 'DISCUSSION_CHANGE',
  index: 0,
  questionId,
  value,
});
